<template>
  <v-icon
    :color="statusData.color"
    :title="statusData.titleMessage"
  >{{ statusData.icon }}</v-icon>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import {DateUtils} from '@/utils/date-utils';

export default {
  name: 'TransactionGuestMailStatus',
  mixins: [
    LocaleUtils,
    DateUtils
  ],
  props: {
    /** @type {TransactionGuestMailStatusDto} */
    status: {
      type: String,
      required: true
    },
    /** @type {TransactionDto} */
    transaction: {
      type: Object,
      required: false
    }
  },
  computed: {
    statusData () {
      let status = {
        icon: 'mdi-email-off',
        color: '#BBB',
        titleMessage: null
      };

      switch (this.status) {
        case 'NOT_YET_DOWNLOADED':
          status.titleMessage = this.trans('transaction.statusGuestMailNotYetDownloaded');
          break;

        case 'MISSING':
          status.titleMessage = this.trans('transaction.statusGuestMailMissing');
          break;

        case 'PENDING':
          status.titleMessage = this.trans('email.titleStatusPending');
          status.icon = 'mdi-email-sync';
          status.color = 'pending';
          break;

        case 'SENT':
          if (this.transaction && this.transaction.sentMailToGuest) {
            status.titleMessage = this.trans('email.titleStatusSentAt', {successfullySentAt: this.formatDate(this.transaction.sentMailToGuest, 'LLL')});
          } else {
            status.titleMessage = this.trans('email.titleStatusSent');
          }
          status.icon = 'mdi-email-send';
          status.color = 'success';
          break;

        case 'ERROR':
          status.titleMessage = this.trans('email.titleStatusFailed');
          status.icon = 'mdi-email-alert';
          status.color = 'error';
          break;

        case 'NOT_NEEDED':
          status.icon = 'mdi-email-remove';
          status.titleMessage = this.trans('transaction.statusGuestMailNotNeeded');
          break;
      }

      return status;
    },
  },
}
</script>
